import { render, staticRenderFns } from "./GroupMenu.vue?vue&type=template&id=4e4bfd2a&"
import script from "./GroupMenu.vue?vue&type=script&lang=ts&"
export * from "./GroupMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports